(function () {
  if (window.__mxSaleGate) return;
  window.__mxSaleGate = true;

  var ATTR = 'data-sale-until';
  var MAX_DELAY = 2147483647;

  var timers = [];
  var fired = false;

  function expirePrice(el) {
    el.dataset.offPercent = '0';
    if (el.dataset.variantPrice) el.dataset.base = el.dataset.variantPrice;
    el.classList.remove('price--on-sale');
  }

  function stripClasses(el) {
    var names = (el.getAttribute('data-sale-strip-class') || '').split(/\s+/);
    for (var i = 0; i < names.length; i++) {
      if (names[i]) el.classList.remove(names[i]);
    }
  }

  function expire(el) {
    var action = el.getAttribute('data-sale-action');

    if (action === 'price') {
      expirePrice(el);
      stripClasses(el);
      el.removeAttribute(ATTR);
    } else if (action === 'strip') {
      stripClasses(el);
      el.removeAttribute(ATTR);
    } else if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
    fired = true;
  }

  function sweep() {
    timers.forEach(clearTimeout);
    timers = [];
    fired = false;

    var now = Date.now();
    var nodes = document.querySelectorAll('[' + ATTR + ']');

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var ends = new Date(el.getAttribute(ATTR)).getTime();
      if (isNaN(ends)) continue;

      if (ends <= now) {
        expire(el);
      } else if (ends - now < MAX_DELAY) {
        timers.push(setTimeout(makeExpire(el), ends - now));
      }
    }

    if (fired) announce();
  }

  function makeExpire(el) {
    return function () {
      expire(el);
      announce();
    };
  }

  function announce() {
    document.dispatchEvent(new CustomEvent('mx:sale-expired'));
  }

  function start() {
    sweep();
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) sweep();
    });
    document.addEventListener('shopify:section:load', sweep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
